<template>
  <div class="AppSelectCoverImgModal">
    <el-dialog
      title="选择封面"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @open="handleOpen"
    >
      <el-radio-group v-model="radio">
        <el-radio v-for="(item, index) in imageList" :key="index" :label="item">
          <img style="height: 112px; width: 160px" :src="item" alt="" />
        </el-radio>
      </el-radio-group>
      <div class="footer">
        <el-button
          size="small"
          style="width: 120px"
          type="primary"
          @click="handleConfirm"
          >确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "AppSelectCoverImgModal",
  props: {
    imageUrl: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      radio: "",
      imageList: [
        "http://jy-static-public.oss-cn-shanghai.aliyuncs.com/static/web/classSubject/cover/%E6%B2%9F%E9%80%9A.png",
        "http://jy-static-public.oss-cn-shanghai.aliyuncs.com/static/web/classSubject/cover/%E8%87%AA%E6%88%91%E7%AE%A1%E7%90%86.png",
        "http://jy-static-public.oss-cn-shanghai.aliyuncs.com/static/web/classSubject/cover/%E8%B4%A3%E4%BB%BB%E6%84%9F.png",
        "http://jy-static-public.oss-cn-shanghai.aliyuncs.com/static/web/classSubject/cover/%E5%BA%94%E5%8F%98.png",
        "http://jy-static-public.oss-cn-shanghai.aliyuncs.com/static/web/classSubject/cover/%E8%A7%A3%E5%86%B3%E9%97%AE%E9%A2%98.png",
        "http://jy-static-public.oss-cn-shanghai.aliyuncs.com/static/web/classSubject/cover/%E6%8A%80%E8%83%BD.png",
        "http://jy-static-public.oss-cn-shanghai.aliyuncs.com/static/web/classSubject/cover/%E4%B8%93%E4%B8%9A%E7%9F%A5%E8%AF%86.png",
      ],
    };
  },
  computed: {
    ...mapState("app", ["appSelectCoverImgModalVisible"]),
    visible: {
      get() {
        return this.$store.state.app.appSelectCoverImgModalVisible;
      },
      set(value) {
        this.$store.commit("app/setData", {
          key: "appSelectCoverImgModalVisible",
          value,
        });
      },
    },
  },
  watch: {
    imageUrl: {
      handler: function (newValue, oldVal) {
        if (newValue !== oldVal) {
          this.imageUrl = newValue;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapMutations("app", ["setDataModal"]),
    handleConfirm() {
      if (this.radio === "") {
        this.$message({
          message: "请选择封面",
          type: "warning",
        });
        return;
      }
      this.$emit("productMaterialUrlChange", this.radio);
      this.setDataModal({
        key: "appSelectCoverImgModalVisible",
        value: false,
      });
    },
    handleOpen() {
      this.radio = this.imageUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
.AppSelectCoverImgModal {
  ::v-deep .el-dialog {
    min-width: 820px !important;
    min-height: 600px;
  }

  ::v-deep .el-dialog .el-dialog__body {
    padding: 20px 30px;
  }

  ::v-deep .el-radio__label {
    display: block;
    padding-left: 0;
    position: relative; /* 添加相对定位 */
    top: -10px; /* 负值将其上移，根据需要调整 */
  }

  ::v-deep .el-radio__input {
    display: block;
    position: relative; /* 添加相对定位 */
    top: 132px; /* 负值将其上移，根据需要调整 */
  }

  ::v-deep .el-radio {
    text-align: center;
    margin-bottom: 50px;
  }

  .footer {
    margin-top: 50px;
    text-align: center;
  }
}
</style>
